import {api} from '../components/Base/App';

export default {
    facebookLogin(code, domain) {
        return api({
            method: 'get',
            url: '/rest/api/jwt/auth/facebook?redirectURI=' + domain,
            params: {
                code: code
            }
        });
    },

    emailLogin(email, password, showErrorModal) {
        return api({
            method: 'get',
            url: '/rest/api/jwt/auth?showErrorModal='+showErrorModal,
            auth: {
                username: email,
                password: password
            }
        });
    },

    register(email, password) {
        return api({
            method: 'post',
            url: '/rest/api/jwt/register',
            headers: {
                'Content-Type': 'application/json',
            },
            data: {
                email: email,
                password: password
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/api/Users.js